import { TireReading } from "../types/TireReadingType";
import { manufacturerMap } from "../constants/manufacturerMap";

export class TireReadingModel {
    checked: boolean;
    constructor(public data: TireReading, checked: boolean = false) {
        this.checked = checked;
    }

    get id() {
        return this.data.id;
    }

    get timestamp() {
        return this.data.timestamp;
    }

    get trigger_id() {
        return this.data.trigger_id;
    }

    get manufacturer_id() {
        return this.data.manufacturer_id;
    }

    get tire_width() {
        return this.data.tire_width;
    }

    get tire_height() {
        return this.data.tire_height;
    }

    get rim_diameter() {
        return this.data.rim_diameter;
    }

    get classifier_outcome() {
        return this.data.classifier_outcome;
    }

    get possible_outcomes() {
        return this.data.possible_outcomes;
    }

    get averageProfileDepth(): number {
        return (
            (this.data.tread_avg_depth_zone_1 +
                this.data.tread_avg_depth_zone_2 +
                this.data.tread_avg_depth_zone_3) /
            3
        );
    }

    get minProfileDepth(): number {
        // return the smallest value of the three zones
        return Math.min(
            this.data.tread_avg_depth_zone_1,
            this.data.tread_avg_depth_zone_2,
            this.data.tread_avg_depth_zone_3
        );
    }

    get manufacturerName(): string {
        return manufacturerMap[this.data.manufacturer_id]?.name ?? "Onbekend";
    }

    get dotCode(): string {
        return `${this.data.dot_part_1} ${this.data.dot_part_2}`;
    }

    get cargo() {
        return this.data.cargo;
    }

    static from(data: TireReading, checked: boolean = false): TireReadingModel {
        return new TireReadingModel(data, checked);
    }
}
